import React, { useState } from 'react';
import { MapPin, Phone, Globe, FileText, Tag, Image, Map } from 'lucide-react';
import { SitemapConfig } from './SitemapConfig';

interface TenantGeneralConfigProps {
  formData: any;
  handleConfigChange: (path: string, value: any) => void;
}

export const TenantGeneralConfig: React.FC<TenantGeneralConfigProps> = ({
  formData,
  handleConfigChange,
}) => {
  const [activeTab, setActiveTab] = useState<'general' | 'seo' | 'sitemap'>('general');
  const seoConfig = formData.config?.seo || {};

  return (
    <div>
      {/* Onglets */}
      <div className="flex space-x-1 mb-6 border-b border-white/10">
        <button
          onClick={() => setActiveTab('general')}
          className={`px-4 py-2 font-medium transition-colors ${
            activeTab === 'general'
              ? 'text-blue-400 border-b-2 border-blue-400'
              : 'text-gray-400 hover:text-gray-200'
          }`}
        >
          <MapPin className="w-4 h-4 inline mr-2" />
          Informations générales
        </button>
        <button
          onClick={() => setActiveTab('seo')}
          className={`px-4 py-2 font-medium transition-colors ${
            activeTab === 'seo'
              ? 'text-blue-400 border-b-2 border-blue-400'
              : 'text-gray-400 hover:text-gray-200'
          }`}
        >
          <Globe className="w-4 h-4 inline mr-2" />
          SEO & Métadonnées
        </button>
        <button
          onClick={() => setActiveTab('sitemap')}
          className={`px-4 py-2 font-medium transition-colors ${
            activeTab === 'sitemap'
              ? 'text-blue-400 border-b-2 border-blue-400'
              : 'text-gray-400 hover:text-gray-200'
          }`}
        >
          <Map className="w-4 h-4 inline mr-2" />
          Sitemap
        </button>
      </div>

      {/* Contenu de l'onglet Général */}
      {activeTab === 'general' && (
        <div>
          <h3 className="text-lg font-medium text-white mb-6 border-b border-white/10 pb-2">Configuration générale</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Pays */}
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">Pays <span className="text-gray-500 text-xs">(tenant.config.country)</span></label>
          <input
            type="text"
            value={formData.config.country || ''}
            onChange={(e) => handleConfigChange('country', e.target.value)}
            placeholder="Cameroun"
            className="w-full px-3 py-2 bg-white/5 border border-white/10 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors"
          />
        </div>
        {/* Ville */}
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">Ville <span className="text-gray-500 text-xs">(tenant.config.city)</span></label>
          <input
            type="text"
            value={formData.config.city || ''}
            onChange={(e) => handleConfigChange('city', e.target.value)}
            placeholder="Yaoundé"
            className="w-full px-3 py-2 bg-white/5 border border-white/10 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors"
          />
        </div>
        {/* Quartier */}
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">Quartier <span className="text-gray-500 text-xs">(tenant.config.neighborhood)</span></label>
          <input
            type="text"
            value={formData.config.neighborhood || ''}
            onChange={(e) => handleConfigChange('neighborhood', e.target.value)}
            placeholder="Bastos"
            className="w-full px-3 py-2 bg-white/5 border border-white/10 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors"
          />
        </div>
        {/* Rue */}
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">Rue <span className="text-gray-500 text-xs">(tenant.config.street)</span></label>
          <input
            type="text"
            value={formData.config.street || ''}
            onChange={(e) => handleConfigChange('street', e.target.value)}
            placeholder="Rue 1234"
            className="w-full px-3 py-2 bg-white/5 border border-white/10 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors"
          />
        </div>
        {/* Adresse complète */}
        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-300 mb-2">Adresse complète <span className="text-gray-500 text-xs">(tenant.config.address)</span></label>
          <input
            type="text"
            value={formData.config.address || ''}
            onChange={(e) => handleConfigChange('address', e.target.value)}
            placeholder="Bastos, Yaoundé, Cameroun"
            className="w-full px-3 py-2 bg-white/5 border border-white/10 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors"
          />
        </div>
        {/* Année */}
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">Année <span className="text-gray-500 text-xs">(tenant.config.year)</span></label>
          <input
            type="text"
            value={formData.config.year || ''}
            onChange={(e) => handleConfigChange('year', e.target.value)}
            className="w-full px-3 py-2 bg-white/5 border border-white/10 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors"
          />
        </div>
        {/* code du pays */}
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">Code du pays <span className="text-gray-500 text-xs">(tenant.config.country_code)</span></label>
          <input
            type="text"
            value={formData.config.country_code || ''}
            onChange={(e) => handleConfigChange('country_code', e.target.value)}
            className="w-full px-3 py-2 bg-white/5 border border-white/10 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors"
          />
        </div>
        {/* Horaires d'ouverture */}
        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-300 mb-2">Horaires d'ouverture <span className="text-gray-500 text-xs">(tenant.config.opening_hours)</span></label>
          <input
            type="text"
            value={formData.config.opening_hours || ''}
            onChange={(e) => handleConfigChange('opening_hours', e.target.value)}
            placeholder="Lun-Sam : 9h-18h, Dim : fermé"
            className="w-full px-3 py-2 bg-white/5 border border-white/10 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors"
          />
        </div>
        {/* Latitude */}
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">Latitude <span className="text-gray-500 text-xs">(tenant.config.latitude)</span></label>
          <input
            type="text"
            value={formData.config.latitude || ''}
            onChange={(e) => handleConfigChange('latitude', e.target.value)}
            placeholder="3.8480"
            className="w-full px-3 py-2 bg-white/5 border border-white/10 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors"
          />
        </div>
        {/* Longitude */}
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">Longitude <span className="text-gray-500 text-xs">(tenant.config.longitude)</span></label>
          <input
            type="text"
            value={formData.config.longitude || ''}
            onChange={(e) => handleConfigChange('longitude', e.target.value)}
            placeholder="11.5021"
            className="w-full px-3 py-2 bg-white/5 border border-white/10 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors"
          />
        </div>
        {/* Lien Google Maps */}
        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-300 mb-2">Lien Google Maps <span className="text-gray-500 text-xs">(tenant.config.google_maps)</span></label>
          <input
            type="url"
            value={formData.config.google_maps || ''}
            onChange={(e) => handleConfigChange('google_maps', e.target.value)}
            placeholder="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d127384.97349942711!2d11.455253845941653!3d3.851954911470438!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x108bcf7a309a7977%3A0x6c6b3788d43a6564!2sYaound%C3%A9!5e0!3m2!1sfr!2scm!4v1672926543210!5m2!1sfr!2scm"
            className="w-full px-3 py-2 bg-white/5 border border-white/10 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors"
          />
        </div>
        {/* Slogan ou phrase d'accroche */}
        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-300 mb-2">Slogan / Accroche <span className="text-gray-500 text-xs">(tenant.config.slogan)</span></label>
          <input
            type="text"
            value={formData.config.slogan || ''}
            onChange={(e) => handleConfigChange('slogan', e.target.value)}
            placeholder="Votre satisfaction, notre priorité !"
            className="w-full px-3 py-2 bg-white/5 border border-white/10 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">Téléphone 1 <span className="text-gray-500 text-xs">(tenant.config.phone)</span></label>
          <input
            type="tel"
            value={formData.config.phone || ''}
            onChange={(e) => handleConfigChange('phone', e.target.value)}
            className="w-full px-3 py-2 bg-white/5 border border-white/10 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">Téléphone 2 <span className="text-gray-500 text-xs">(tenant.config.phone2)</span></label>
          <input
            type="tel"
            value={formData.config.phone2 || ''}
            onChange={(e) => handleConfigChange('phone2', e.target.value)}
            className="w-full px-3 py-2 bg-white/5 border border-white/10 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">Téléphone 3 <span className="text-gray-500 text-xs">(tenant.config.phone3)</span></label>
          <input
            type="tel"
            value={formData.config.phone3 || ''}
            onChange={(e) => handleConfigChange('phone3', e.target.value)}
            className="w-full px-3 py-2 bg-white/5 border border-white/10 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">Téléphone 4 <span className="text-gray-500 text-xs">(tenant.config.phone4)</span></label>
          <input
            type="tel"
            value={formData.config.phone4 || ''}
            onChange={(e) => handleConfigChange('phone4', e.target.value)}
            className="w-full px-3 py-2 bg-white/5 border border-white/10 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors"
          />
        </div>
      </div>
        </div>
      )}

      {/* Contenu de l'onglet SEO */}
      {activeTab === 'seo' && (
        <div className="space-y-8">
          <h3 className="text-lg font-medium text-white mb-6 border-b border-white/10 pb-2 flex items-center">
            <Globe className="w-5 h-5 mr-2" />
            Configuration SEO & Métadonnées
          </h3>

          <div className="bg-blue-500/10 border border-blue-500/20 rounded-lg p-4 mb-6">
            <p className="text-sm text-blue-200">
              <strong>💡 Info :</strong> Ces paramètres remplacent dynamiquement les balises HTML <code>&lt;title&gt;</code>, 
              <code>&lt;meta&gt;</code> et <code>&lt;link&gt;</code> en fonction du domaine. 
              Chaque tenant aura son propre titre, description et favicon.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-6">
            {/* Icône/Favicon */}
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2 flex items-center">
                <Image className="w-4 h-4 mr-2" />
                Icône du site (Favicon)
                <span className="text-gray-500 text-xs ml-2">(tenant.config.icon)</span>
              </label>
              <input
                type="url"
                value={formData.config.icon || ''}
                onChange={(e) => handleConfigChange('icon', e.target.value)}
                className="w-full px-4 py-2 bg-white/5 border border-white/10 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="https://votre-domaine.com/favicon.png"
              />
              <p className="text-xs text-gray-400 mt-1">
                URL de l'icône affichée dans l'onglet du navigateur (format PNG, ICO ou SVG recommandé)
              </p>
              {formData.config.icon && (
                <div className="mt-2 flex items-center space-x-2">
                  <img src={formData.config.icon} alt="Favicon" className="w-8 h-8 rounded" onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }} />
                  <span className="text-xs text-gray-400">Aperçu du favicon</span>
                </div>
              )}
              <p className="text-xs text-yellow-400 mt-2">
                ⚠️ Si vide, le logo du tenant sera utilisé automatiquement comme favicon
              </p>
            </div>

            {/* Titre de la page */}
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2 flex items-center">
                <FileText className="w-4 h-4 mr-2" />
                Titre de la page (SEO Title)
                <span className="text-gray-500 text-xs ml-2">(tenant.config.seo.title)</span>
              </label>
              <input
                type="text"
                value={seoConfig.title || ''}
                onChange={(e) => handleConfigChange('seo.title', e.target.value)}
                className="w-full px-4 py-2 bg-white/5 border border-white/10 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder={`Ex: ${formData.name} | Votre slogan`}
              />
              <p className="text-xs text-gray-400 mt-1">
                Affiché dans l'onglet du navigateur et les résultats de recherche (50-60 caractères recommandés)
              </p>
            </div>

            {/* Description */}
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2 flex items-center">
                <FileText className="w-4 h-4 mr-2" />
                Description (Meta Description)
                <span className="text-gray-500 text-xs ml-2">(tenant.config.seo.description)</span>
              </label>
              <textarea
                value={seoConfig.description || ''}
                onChange={(e) => handleConfigChange('seo.description', e.target.value)}
                rows={3}
                className="w-full px-4 py-2 bg-white/5 border border-white/10 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Décrivez votre activité en quelques phrases..."
              />
              <p className="text-xs text-gray-400 mt-1">
                Résumé affiché dans les résultats de recherche (150-160 caractères recommandés)
              </p>
            </div>

            {/* Image OG (Open Graph) */}
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2 flex items-center">
                <Image className="w-4 h-4 mr-2" />
                Image Open Graph (OG Image)
                <span className="text-gray-500 text-xs ml-2">(tenant.config.seo.ogImage)</span>
              </label>
              <input
                type="url"
                value={seoConfig.ogImage || ''}
                onChange={(e) => handleConfigChange('seo.ogImage', e.target.value)}
                className="w-full px-4 py-2 bg-white/5 border border-white/10 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="https://votre-domaine.com/og-image.jpg"
              />
              <p className="text-xs text-gray-400 mt-1">
                Image affichée lors du partage sur les réseaux sociaux (1200x630px recommandé)
              </p>
              {seoConfig.ogImage && (
                <div className="mt-2">
                  <img 
                    src={seoConfig.ogImage} 
                    alt="OG Image Preview" 
                    className="w-full max-w-md h-auto rounded border border-white/10" 
                    onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }} 
                  />
                </div>
              )}
              <p className="text-xs text-yellow-400 mt-2">
                ⚠️ Si vide, le logo du tenant sera utilisé automatiquement comme image OG
              </p>
            </div>

            {/* Mots-clés */}
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2 flex items-center">
                <Tag className="w-4 h-4 mr-2" />
                Mots-clés (Keywords)
                <span className="text-gray-500 text-xs ml-2">(tenant.config.seo.keywords)</span>
              </label>
              <input
                type="text"
                value={seoConfig.keywords || ''}
                onChange={(e) => handleConfigChange('seo.keywords', e.target.value)}
                className="w-full px-4 py-2 bg-white/5 border border-white/10 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="mot-clé 1, mot-clé 2, mot-clé 3..."
              />
              <p className="text-xs text-gray-400 mt-1">
                Séparez les mots-clés par des virgules (utilisé pour le référencement)
              </p>
            </div>

            {/* Aperçu */}
            <div className="bg-white/5 border border-white/10 rounded-lg p-4">
              <h4 className="text-sm font-semibold text-white mb-3">📱 Aperçu dans les résultats de recherche</h4>
              <div className="bg-white rounded-lg p-4 space-y-1">
                <div className="text-blue-600 text-lg font-medium truncate">
                  {seoConfig.title || formData.name || 'Titre de votre site'}
                </div>
                <div className="text-green-700 text-xs">
                  {formData.domain_name || 'votre-domaine.com'}
                </div>
                <div className="text-gray-600 text-sm line-clamp-2">
                  {seoConfig.description || 'Votre description apparaîtra ici...'}
                </div>
              </div>
            </div>

            {/* Informations supplémentaires */}
            <div className="bg-gray-800/50 border border-gray-700 rounded-lg p-4">
              <h4 className="text-sm font-semibold text-white mb-2">ℹ️ Informations automatiques</h4>
              <ul className="text-xs text-gray-300 space-y-1">
                <li>• <strong>Favicon :</strong> Utilise l'icône ci-dessus ou le logo du tenant si vide</li>
                <li>• <strong>Image OG :</strong> Utilise l'image OG ci-dessus ou le logo du tenant si vide</li>
                <li>• <strong>URL Canonique :</strong> Générée automatiquement depuis le domaine</li>
                <li>• <strong>Open Graph :</strong> Tags sociaux (Facebook, LinkedIn) générés automatiquement</li>
                <li>• <strong>Twitter Card :</strong> Aperçu Twitter généré automatiquement</li>
                <li>• <strong>Theme Color :</strong> Utilise la couleur primaire du tenant</li>
              </ul>
            </div>
          </div>
        </div>
      )}

      {/* Contenu de l'onglet Sitemap */}
      {activeTab === 'sitemap' && (
        <SitemapConfig formData={formData} handleConfigChange={handleConfigChange} />
      )}
    </div>
  );
};
